import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import {
  useLazyRequestPropertyListQuery,
  useLazyRequestPropertyStatusQuery,
} from "../../redux/api/api";
import { editIcon, viewIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import Swal from "sweetalert2";

const PropertyRequest = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [row, setRow] = useState(10);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [requestPropertyApi] = useLazyRequestPropertyListQuery();
  const [requestPropertyStatusApi] = useLazyRequestPropertyStatusQuery();

  const getRequestProperty = (search_value, row_value) => {
    let params = `?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setSearch(search_value);
    setRow(row_value);
    dispatch(saveLoader(true));
    requestPropertyApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.properties);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getRequestProperty(search, row);
  }, [page]);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  const rejectionConfirm = (property_id, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reject it!",
    }).then((result) => {
      if (result.isConfirmed) {
        statusChange(property_id, status);
      }
    });
  };

  const statusChange = (property_id, status) => {
    let id = property_id + "/" + status;
    dispatch(saveLoader(true));
    setBtn(true);
    requestPropertyStatusApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          getRequestProperty(search, row);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"property-request-list"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <label className="table-labels f1">
                Total Count : {pagination?.total}
              </label>
            </Col>
            <Col sm={6} md={6}>
              <div className="d-flex ac-je block-header add-btn">
                <button
                  className="f1 d-flex"
                  onClick={() => navigate("/property")}
                >
                  <AddIcon />
                  Add Request Property
                </button>
              </div>
            </Col>
          </Row>
          <div className="d-flex ac-jb">
            <div className="col-md-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) => getRequestProperty(search, e.target.value)}
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="mb-2">
              <input
                className="form-control bg-white"
                placeholder="Eg: Name, City, State, Location"
                style={{ width: "300px" }}
                onChange={(e) => getRequestProperty(e.target.value, row)}
                value={search}
              />
            </div>
          </div>
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize text-nowrap">
                  <th>S.NO</th>
                  <th>Property ID</th>
                  <th>Property Name</th>
                  <th>Image</th>
                  <th>State</th>
                  <th>City</th>
                  <th>Location</th>
                  <th>Landmark</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{(pagination?.current_page - 1) * row + ind + 1}</td>
                      <td>{item?.property_id}</td>
                      <td>{item?.name}</td>
                      <td>
                        <img
                          src={item?.image}
                          alt="property-img"
                          style={{ width: "100px", height: "80px" }}
                          class="img-fluid"
                        />
                      </td>
                      <td>{item?.state?.name}</td>
                      <td>{item?.city?.name}</td>
                      <td>{item?.location?.name}</td>
                      <td>{item?.landmark}</td>
                      <td>
                        <div className="d-flex flex-column">
                          <button
                            className={`btn-success px-2 py-1 rounded-1 border-0 text-white`}
                            onClick={() => statusChange(item?.id, "1")}
                            disabled={btn}
                          >
                            Accept
                          </button>

                          <button
                            className={`btn-danger px-2 py-1 rounded-1 border-0 text-white mt-1`}
                            onClick={() => rejectionConfirm(item?.id, "0")}
                            disabled={btn}
                          >
                            Reject
                          </button>
                        </div>
                      </td>
                      <td>
                        <button
                          className="cust-btn"
                          onClick={() =>
                            navigate("/property-request-view", {
                              state: { type: "view", data: item },
                            })
                          }
                        >
                          <img src={viewIcon} className="edit-btn" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyRequest;
